/*
 * @Description: 代办供应商-个体户管理-代办/客户个体
 * @Date: 2026-04-07 15:25:48
 */

import { route } from './src/router';

const name = 'individual-household';

export { name, route };
